import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	
  	render() {
		return (
			<div className="HereoBanner TestiBack">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">CAREERS</h2>
						<div className="red-border"> </div>
						<p>At DigiPanda, we don't just build a team; we add them to our part of the family, in which they can grow, earn and take their life to a better place. </p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
